import { useShareMailboxContext } from '@utils';
import { ActionTaken, getIsOnPremises, getMailId, getUserEmail } from '@utils-global';
import { useState } from 'react';

// To store page state
export const useReport = () => {
  const [actionsTaken, setActionsTaken] = useState<ActionTaken[]>([]);
  const [keepEmail, setKeepEmail] = useState(false);
  const { isSharedMailbox, sharedProperties, originalUserEmail } = useShareMailboxContext();

  const mailId = getMailId();
  const isOnPremises = getIsOnPremises();
  // if it's shared mailbox we should use mailbox mail address instead of user email
  // if it's ordinary mailbox user email === mailbox email
  const mailboxEmail =
    isSharedMailbox && sharedProperties?.targetMailbox
      ? sharedProperties.targetMailbox
      : getUserEmail();

  return {
    mailId,
    mailboxEmail,
    actionsTaken,
    isOnPremises,
    originalUserEmail,
    isSharedMailbox,
    setActionsTaken,
    keepEmail,
    setKeepEmail,
  };
};
